module.exports = __webpack_public_path__ + "static/media/b0_p11_clickable_c.14657f8f.mp3";